import makeStyles from '@mui/styles/makeStyles';
import { useDrag } from 'react-dnd';

const useStyles = makeStyles(() => ({
  box: {
    border: '1px dashed gray',
    backgroundColor: 'white',
    padding: '0.5rem 1rem',
    cursor: 'move',
    width: '100%',
  },
}));

type DragContainerProps = {
  children: React.ReactNode;
  item: {
    name: string;
    type: string;
  };
};

export const DragContainer = ({ children, item }: DragContainerProps) => {
  const classes = useStyles();
  const { name, type } = item;
  const [{ opacity }, drag] = useDrag(
    () => ({
      type,
      item,
      collect: monitor => ({
        opacity: monitor.isDragging() ? 0.4 : 1,
      }),
    }),
    [name, type],
  );

  return (
    <div ref={drag} className={classes.box} style={{ opacity }}>
      {children}
    </div>
  );
};
